
    import store from '../../../store'
    import {
        Vue,
        Component
    } from 'vue-property-decorator'
    // import GangdianUser from './gangdian-user'
    import AddOrUpdate from  './kqrules-add-or-update'
    import SetUser from  './kqrules-setuser'
    // import SetTempUser from './gangdian-settempuser'
    import GangdianUser from './kqrules-user'
    @Component({
        name: 'kqrules',
        components:{
            AddOrUpdate,
            SetUser,
            GangdianUser
        }
    })

    export default class zgxq extends Vue {

        username=store.getters.user.username
        ruleName=''
        bmid=''
        zyxm=''
        deptdisable=false
        depts=[]
        currentPage=1
        pagesize=10
        total=0
        loading=true
        tableData=[]
        userVisible=false
        updateVisible=false
        setUsetVisible=false
        setUsetTempVisible=false

        mounted() {
            let that = this;
            this.getDepts()


        }
        goMap() {
            this.$router.push({path:'/bjba/map'});
        }
        loadData() {
            this.$request({
                method: 'get',
                url: '/bjba/kqrules/page',
                params:{
                    page:this.currentPage,
                    pagesize:this.pagesize,
                    ruleName:this.ruleName,
                    bmid:this.bmid,
                    zyxm:this.zyxm
                }
            }).then((response: any) => {
                this.loading=false
                this.tableData = response.data.data.data
                this.total = response.data.data.count
            })
        }
        deClick(index, row) {
            let that=this;
            that.$confirm('是否确定删除此考勤组', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$request({
                    method: 'post',
                    url: '/bjba/kqrules/deleteKqRules',
                    params: {
                        id: row.id
                    }
                }).then((response: any) => {
                    this.$message.success("删除成功！");
                    this.loadData();
                }).catch(err => {
                    console.log(err)
                    alert("删除失败！")
                })
            }).catch(() => {});
        }
        updateClick(row) {
            this.updateVisible = true
            this.$nextTick(() => {
                this.$refs.update.init(row)
            })
        }
        getDepts() {
            let that = this;
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }

            }).then(res => {
                that.depts = res.data
                if(this.depts && this.depts[0]) {

                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if(zzdyqc){
                        if(this.CONST_MOSTHIGH_DEPTS&&this.CONST_MOSTHIGH_DEPTS.includes&&!this.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
                            var zw = this.$store.getters.user.zw;

                            if(zw) {
                                if(zw=='01'||zw=='02'||zw=='03') {
                                    this.bmid = that.depts[0].bmid
                                    this.deptdisable = true

                                }

                            }
                        }

                    }

                }
                this.loadData();
            })
        }
        pageUser(page) {
            this.currentPage = page
            this.loadData()
        }
        changeIndex() {
            this.currentPage = 1
        }
        dwClick(row) {
            let x = row.zbjd;
            let y = row.zbwd;
            this.$router.push({path:'/bjba/map',
                query:{x:x,y:y}});
        }
        showUser(row) {
            this.userVisible = true
            this.$nextTick(() => {
                this.$refs.user.init(row.id,this.zyxm)
            })
        }
        setUser(row) {
            this.setUsetVisible = true
            this.$nextTick(() => {
                this.$refs.setuser.init(row.id)
            })
        }
        setTempUser(row) {
            this.setUsetTempVisible = true
            this.$nextTick(() => {
                this.$refs.setusertemp.init(row.gdid)
            })
        }
    }
